"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _UIConfirmDialog = _interopRequireDefault(require("./UIConfirmDialog"));

var _UIModal = _interopRequireDefault(require("./UIModal"));

var _default = _react.default.createClass({
  displayName: "UIConfirmModal",
  propTypes: (0, _extends2.default)({}, _UIConfirmDialog.default.propTypes, {
    _contextual: _react.PropTypes.bool
  }),
  contextTypes: {
    sandboxed: _react.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UIConfirmDialog.default.defaultProps, {
      onReject: _emptyFunction.default,
      _contextual: false
    });
  },
  render: function render() {
    return _react.default.createElement(_UIModal.default, (0, _extends2.default)({}, this.props, {
      ModalDialog: _UIConfirmDialog.default
    }));
  }
});

exports.default = _default;
module.exports = exports.default;